import React, { useState, useEffect, createContext, useContext  } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../../../css/form.css';
import CreateCoffee from "./create/createCoffee";
import UpdateCoffee from "./update/updateCoffee";
import { API } from "../../../services/api";
import axios from "axios";
import {UserContext } from "../../../App";

axios.defaults.baseURL = API;

const CoffeeContext = createContext();

function Coffee() {

  const {userID, showForm, setShowForm, setshowSubmenu} = useContext(UserContext);
  const [CoffeeList, setCoffeeList] = useState([]);
  const [CountryList, setCountryList] = useState([]);
  const [FarmList, setFarmList] = useState([]);
  const [TypeList, setTypeList] = useState([]);
  const [GradeList, setGradeList] = useState([]);
  const [BeanStatusList, setBeanStatusList] = useState([]);
  const [ProccessList, setProccessList] = useState([]);
  const [RoasterTypeList, setRoasterTypeList] = useState([]);
  const [showData, setShowData] = useState([]);
  const [data, setData] = useState([]);

  const [show, setShow] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);

  const handleCloseUpdate = () => setShowUpdate(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  async function HandleSearchCoffeeByBarcode (event) {
    const {value } = event.target;
    if(value){
      let token = localStorage.getItem("token");
      await axios.put(`/SearchCoffeeByBarcode/${value}`, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
        let temOrder = response?.data;
        if(temOrder.length > 0){
          setShowData(temOrder);
        }else {
          setShowData(CoffeeList);
        }
      }).catch((err) => {
          console.log(err);
      });
    } else {
      setShowData(CoffeeList);
    }
  }

  async function SearchCoffeeByProductName (event) {
    const {value } = event.target;
    if(value){
      let token = localStorage.getItem("token");
      await axios.put(`/SearchCoffeeByProductName/${value}`, { headers: { Authorization: `MR_ADMIN ${token}`}}).then((response) => {
        let temOrder = response?.data;
        if(temOrder.length > 0){
          setShowData(temOrder);
        } else {
          setShowData(CoffeeList);
        }
      }).catch((err) => {
          setShowData(CoffeeList);
          console.log(err);
      });
    } else {
      setShowData(CoffeeList);
    }
  }

  const openUpdate = (CoffeeID, Barcode, ProductName, Buy_Price, Sell_Price, CountryID, Country, FarmID, Farm, TypeID, Type, VarityID, Varity, GradeID, Grade, BeanStatusID, BeanStatus, ProccessID, Proccess, RoasterID, Roaster, TestNote) => {
    var list = [];
    list.push({
     CoffeeID: CoffeeID,
     Barcode: Barcode,
     ProductName: ProductName,
     Buy_Price: Buy_Price,
     Sell_Price: Sell_Price,
     CountryID: CountryID,
     Country: Country,
     FarmID: FarmID,
     Farm: Farm, 
     TypeID: TypeID, 
     Type: Type, 
     VarityID: VarityID, 
     Varity:  Varity,
     GradeID: GradeID, 
     Grade: Grade, 
     BeanStatusID: BeanStatusID, 
     BeanStatus: BeanStatus,
     ProccessID: ProccessID, 
     Proccess: Proccess, 
     RoasterID: RoasterID, 
     Roaster: Roaster, 
     TestNote: TestNote
    });
    setData(list);
    setShowUpdate(true);
  };

  async function getAllCoffee() {
    axios.get("/getAllCoffee").then((response) => {
      let Data = response?.data;
      setCoffeeList(Data);
      setShowData(Data);
    }).catch((error) => {
      console.log(error);
    });
  }

  async function getAllCountry() {
    axios
      .get("/getAllCountry")
      .then((response) => {
        let Data = response?.data;
        setCountryList(Data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getAllFarm() {
    axios
      .get("/getAllFarm")
      .then((response) => {
        let Data = response?.data;
        setFarmList(Data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getAllType() {
    axios
      .get("/getAllType")
      .then((response) => {
        let Data = response?.data;
        setTypeList(Data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getAllGrade() {
    axios
      .get("/getAllGrade")
      .then((response) => {
        let Data = response?.data;
        setGradeList(Data);
      })
      .catch((error) => {
        console.log(error);
      });
  }


  async function getAllBeanStatus() {
    axios
      .get("/getAllBeanStatus")
      .then((response) => {
        let Data = response?.data;
        setBeanStatusList(Data);
      })
      .catch((error) => {
        console.log(error);
      });
  }


  async function getAllProccess() {
    axios
      .get("/getAllProccess")
      .then((response) => {
        let Data = response?.data;
        setProccessList(Data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async function getAllRoasterType() {
    axios
      .get("/getAllRoasterType")
      .then((response) => {
        let Data = response?.data;
        setRoasterTypeList(Data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const handleclickBack = () => {
        setShowForm(false);
        setshowSubmenu(true);
    };

  useEffect(() => {
    getAllCoffee();
    getAllCountry();
    getAllFarm();
    getAllType();
    getAllGrade();
    getAllBeanStatus();
    getAllProccess();
    getAllRoasterType();
  }, []);

  return (
    <CoffeeContext.Provider value={{CoffeeList, setCoffeeList, setShowData, CountryList, FarmList, TypeList, GradeList, BeanStatusList, ProccessList, RoasterTypeList, data}}>
      <div className="formContent">
        <CreateCoffee show={show} onClick={handleClose}/>
        <UpdateCoffee show={showUpdate} onClick={handleCloseUpdate}/>
        <div className="formCard">
        <div className="Header">
          <div className="title">
              <span>ຂໍ້ມູນ ເມັດກາເຟ</span>
          </div>
          <div className="buttonContent">
              <button className="btn btn-primary" onClick={handleShow} >ເພີ່ມ</button>
              <button className="btn btn-danger" onClick={() => handleclickBack()} >Back</button>
            </div>
        </div>
        <div className="Body">
          <div className="txtSearch">
            <input placeholder="ຄົ້ນຫາດ້ວຍ Barcode" name="Barcode" onChange={(e) => HandleSearchCoffeeByBarcode(e)} />
            <input placeholder="ຄົ້ນຫາຊື່" name="LaoName" onChange={(e) => SearchCoffeeByProductName(e)} />
          </div>
          <table className="styled-table">
            <thead>
              <tr key={1}>
                <th>ລ/ດ</th>
                <th>Barcode</th>
                <th>ຊື່ເມັດກາເຟ</th>
                <th>ລາຄາຊື້</th>
                <th>ລາຄາຂາຍ</th>
                <th>ປະເທດ</th>
                <th>ສວນ</th>
                <th>ປະເພດ</th>
                <th>ສາຍພັນ</th>
                <th>ເກດເມັດ</th>
                <th>ສະຖານະເມັດ</th>
                <th>Proccess</th>
                <th>ປະເພດຂົ້ວ</th>
                <th>ລົດຊາດ</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {
                showData && showData.map((x, y) => {
                    return (
                      <tr key={y}>
                        <td >{y + 1}</td>
                        <td >{x.Barcode}</td>
                        <td >{x.ProductName }</td>
                        <td >{x.Buy_Price}</td>
                        <td >{x.Sell_Price}</td>
                        <td >{x.Country}</td>
                        <td >{x.Farm}</td>
                        <td >{x.Type }</td>
                        <td >{x.Varity}</td>
                        <td >{x.Grade}</td>
                        <td >{x.BeanStatus}</td>
                        <td >{x.Proccess}</td>
                        <td >{x.Roaster}</td>
                        <td >{x.TestNote}</td>
                        <td >
                          <button className="btn btn-secondary" value={x.CoffeeID} type="button" onClick={() => openUpdate(x.CoffeeID, x.Barcode, x.ProductName, x.Buy_Price, x.Sell_Price, x.CountryID, x.Country, x.FarmID, x.Farm, x.TypeID, x.Type, x.VarityID, x.Varity, x.GradeID, x.Grade, x.BeanStatusID, x.BeanStatus, x.ProccessID, x.Proccess, x.RoasterID, x.Roaster, x.TestNote)}>ແກ້ໄຂ</button>
                        </td>
                      </tr>
                    )
                })
              }
            </tbody>
          </table>
          </div>
        </div>
      </div>
    </CoffeeContext.Provider>
  );
};

export {CoffeeContext};
export default Coffee;
